import { apiV2, errorHandler } from './index';
import {
  API_ERROR,
  FETCH_FEEDBACKS,
} from '../constants/ActionTypes';
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '../constants/pagination';

export function fetchFeedbacks(page = 1, page_size = DEFAULT_PER_PAGE, search = '') {
  return function (dispatch) {
    apiV2.get(`/feedbacks`, {
      params: {
        page,
        page_size,
        search,
      }
    })
      .then(response => {
        dispatch({
          type: FETCH_FEEDBACKS,
          payload: { ...response.data, per_page: page_size }
        });
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}
